import { render, staticRenderFns } from "./ViewerQuillComponent.vue?vue&type=template&id=d2fb260c&scoped=true&"
import script from "./ViewerQuillComponent.vue?vue&type=script&lang=js&"
export * from "./ViewerQuillComponent.vue?vue&type=script&lang=js&"
import style0 from "./ViewerQuillComponent.vue?vue&type=style&index=0&id=d2fb260c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fb260c",
  null
  
)

export default component.exports